import type React from "react";

import styled from "styled-components";

interface DropDownOptionsProps {
  parentId: string;
  children?: React.ReactNode;
  small?: boolean;
  className?: string;
  dropdownListMinWidth?: string;
}

export const DropDownOptions: React.FC<DropDownOptionsProps> = ({
  parentId,
  children,
  small,
  className,
  dropdownListMinWidth,
}) => {
  return (
    <DropdownList
      id={`${parentId}-dropdown-list`}
      $small={small}
      className={className}
      $dropdownListMinWidth={dropdownListMinWidth}
    >
      <ListContainer>{children}</ListContainer>
    </DropdownList>
  );
};

const DropdownList = styled.ul<{ $small?: boolean; $dropdownListMinWidth?: string }>`
  margin: 0;
  padding: 0px 0px;
  top: 100%;
  min-width: ${({ $dropdownListMinWidth }) => $dropdownListMinWidth || "221px"};
  border-radius: 8px;
  background-color: ${props => props.theme.colors.white};
  box-shadow: 0px 10px 20px ${props => props.theme.colors.greys.pinkish};
  border: 1px solid ${props => props.theme.colors.redesign.db20};
  z-index: ${props => props.theme.zIndex.modal};
  ${props => props.theme.belowBreakpoint} {
    top: 48px;
    border-radius: 8px;
  }
  overflow: hidden;
`;

const ListContainer = styled.div`
  width: 100%;
`;
